import request from "@/api/request";

export default {
    // 获取客户积分设置
    getDetail: async data => request({url: '/console/integral.Rule/getDetail', data}),
    // 编辑客户积分设置
    editRule: async data => request({url: '/console/integral.Rule/editRule', data}),
}
